import { render, staticRenderFns } from "./DataBuildMatchedMlAccounts.vue?vue&type=template&id=904c9efe&scoped=true"
import script from "./DataBuildMatchedMlAccounts.vue?vue&type=script&lang=js"
export * from "./DataBuildMatchedMlAccounts.vue?vue&type=script&lang=js"
import style0 from "./DataBuildMatchedMlAccounts.vue?vue&type=style&index=0&id=904c9efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904c9efe",
  null
  
)

export default component.exports